const FloatLabel = (() => {
    // add filled class
    const handleFocus = (e) => {
        const target = e.target;
        target.parentNode.classList.add('filled');
        target.setAttribute('placeholder', target.getAttribute('data-placeholder'));
    };

    // remove filled class
    const handleBlur = (e) => {
        const target = e.target;
        if(!target.value) {
            target.parentNode.classList.remove('filled');
        }
        target.removeAttribute('placeholder');
    };

    // register events
    const bindEvents = (element) => {
        const floatField = element.querySelector('.form-control');
        floatField.addEventListener('focus', handleFocus);
        floatField.addEventListener('blur', handleBlur);
    };

    // get DOM elements
    const init = () => {
        const formGroup = document.querySelectorAll('.form-group');

        formGroup.forEach((element) => {

            if (element.querySelector('.form-control').value) {
                element.classList.add('filled');
            }

            bindEvents(element);
        });
    };

    return {
        init: init
    };
})();


/**
 * only for exisitng old forms
 * show label | remove placeholder | switch order of label and input
 */
function adjustForm() {
    jQuery('form .form-group').each(function(i, formGroup) {

        var lable = jQuery( formGroup ).find('label');
        var formControl = jQuery( formGroup ).find('.form-control');

        if( jQuery(formControl).length === 0 ) {
            formControl = jQuery(lable).siblings('input');
            jQuery(formControl).addClass('form-control');
        }

        jQuery( lable ).removeClass('sr-only');
        jQuery( formControl ).removeClass('input-lg').attr('placeholder', '');

        // if label before formfield => switch it
        if( jQuery(formControl).prev('label').length > 0 ) {
            jQuery( lable ).before(jQuery(formControl));
        }
    });
}

if( hwk_variables.hwk_form_floating_labels ) {
    adjustForm();
    FloatLabel.init();
}